import javaBackendAxios from "../axios"

export const createChat = async (chatName: string, caseId: string, llmOptions: string[]) => {
    try {
        const response = await javaBackendAxios.post(`/api/java/chat`, {
            chatName, caseId, llmOptions
        });
        return await response.data;
    } catch (error) {
        console.error("Błąd podczas tworzenia chatu", error);
        throw error;
    }
};
export const editChatName = async (caseId: string, chatId: string, name: string) => {
    try {
        const response = await javaBackendAxios.put(`/api/java/chat/${chatId}/case/${caseId}`, {
            chatName: name
        });
        return await response.data;
    } catch (error) {
        console.error("Błąd podczas edycji chatu", error);
        throw error;
    }
};
export const getChatIdForCase = async () => {
    try {
        const response = await javaBackendAxios.get(`/api/java/chat/generate-token`);
        return await response.data;
    } catch (error) {
        console.error("Błąd podczas generowania chatu:", error);
        throw error;
    }
};
export const getChatListForCase = async (caseId: string) => {
    try {
        const response = await javaBackendAxios.get(`/api/java/chat/case/${caseId}/chat-list`);
        return await response.data;
    } catch (error) {
        console.error("Błąd podczas pobierania listy chatów:", error);
        throw error;
    }
};
export const getChatHistory = async (caseId: string, chatId: string) => {
    try {
        const response = await javaBackendAxios.get(`/api/java/chat/${chatId}/case/${caseId}/history`);
        return await response.data;
    } catch (error) {
        console.error("Błąd podczas pobierania historii chatu:", error);
        throw error;
    }
}
export const sendMessage = async (caseIdParam: string, chatId: string,
                                  question:{ query: string,
                                      attachedFile: { file_id: number }[],
                                      llmOptions: string[],
                                      lang: string,
                                      modelEndpointKey: string
                                  }) => {
    try {
        const response = await javaBackendAxios.post(`/api/java/chat/${chatId}/case/${caseIdParam}/question`,
            { ...question })

        if (response.status >= 200 && response.status < 300) {
            return await response.data;
        } else {
            throw new Error(`Error: Received status code ${response.status}`);
        }
    } catch (error) {
        console.error("Błąd podczas wysyłania wiadomości:", error);
        throw error;
    }
}

export const messageResponse = async (caseIdParam: string, chatId: string, messageId: string) => {
    try {
        const response = await javaBackendAxios.get(`/api/java/chat/${chatId}/case/${caseIdParam}/message/${messageId}`)
        if (response.status >= 200 && response.status < 300) {
            return response.data;
        }
    } catch (error) {
        console.error("Błąd podczas pobierania wiadomości:", error);
        throw error;
    }
}

export const removeChat = async (caseId: string, chatId: string) => {
    try {
        const response = await javaBackendAxios.delete(`/api/java/chat/${chatId}/case/${caseId}`);
        return await response.data;
    } catch (error) {
        console.error("Błąd podczas usuwania chatu:", error);
        throw error;
    }
}